import React from 'react'
import Skeleton from "react-loading-skeleton";
import { UiComponents } from "@simulanisindia/ui";


const { GridView, NormalGradientButton } = UiComponents;


const GroupCardSkeleton = ({ length = 5 }) => {
  return (
    <>
    <GridView>
    {Array.from({ length }).map((_, index) => (
        <div className="org-card">
          <div className="profile">
                <Skeleton circle width="80%" height="80%" />
          </div>
          <div className="names-info w-100">
            <p className="name w-100">
            <Skeleton width="80%" height="1rem" />
            </p>
            <p className="p-name w-100">
            <Skeleton width="80%" height="1rem" />
            </p>
          </div>
          <div className="counts-here w-100">
            <span className="count-item align-item-start w-100">
            <Skeleton width="80%" height="2rem"/>
            </span>
           <span className="count-item align-item-start w-100">
            <Skeleton width="80%" height="2rem"/>
            </span>
          </div>
    
        
            <div className="action-item ps-0">
              <p className="amount">
              <Skeleton width="4rem" height="2rem"/>
              </p>
              <button className="action-btn pt-1 ">
              <Skeleton width="3rem" height="100%" baseColor='#00000000'/>
              </button>
            </div>
            
        </div>
         ))}
         </GridView>
  </>
  )
}

export default GroupCardSkeleton